const data_ids = {
  //开模数
  // '0XF29C4': 'SHOT_COUNT',
  //温度
  '0X80F2848': 'ACTUAL_TEMP1',
  '0X80F47D0': 'SET_TEMP1',
  '0X80F2849': 'ACTUAL_TEMP2',
  '0X80F47D1': 'SET_TEMP2',
  '0X80F284A': 'ACTUAL_TEMP3',
  '0X80F47D2': 'SET_TEMP3',
  '0X80F284B': 'ACTUAL_TEMP4',
  '0X80F47D3': 'SET_TEMP4',
  '0X80F284C': 'ACTUAL_TEMP5',
  '0X80F47D4': 'SET_TEMP5',
  '0X80F284D': 'ACTUAL_TEMP6',
  '0X80F47D5': 'SET_TEMP6',
  '0x001FFBB6': 'AUSTON_ACTUALDATA_POWERTEMP1',
  '0x001FFF9E': 'AUSTON_ACTUALDATA_POWERTEMP2',
  '0x001FFBB5': 'MOTORTEMP1',
  '0x001FFF9D': 'MOTORTEMP2',
  //品质
  '0XF2032': 'CYCLE_TIME',
  '0XF2033': 'CLAMP_CLOSE_TIME',
  '0XF2034': 'INJECT_TIME',
  '0XF2035': 'TURN_TIME',
  '0XF2036': 'CHARGE_TIME',
  '0XF2037': 'CLAMP_OPEN_TIME',
  '0XF2038': 'INJECT_BACK_TIME',
  '0XF2039': 'EJECT_TIME',
  '0XF203B': 'CLAMP_OPEN_POSITION',
  '0XF2208': 'INJECT_START_POSITION',
  '0XF2209': 'INJECT_END_POSITION',
  '0XF220A': 'TURN_POSITION',
  '0XF244C': 'TURN_PRESSURE',
  '0XF244D': 'INJECT_MAX_PRESSURE',
  '0XF244E': 'CHARGE_MAX_PRESSURE',
};

const quality_ids = [
  '0XF2032',
  '0XF2033',
  '0XF2034',
  '0XF2035',
  '0XF2036',
  '0XF2037',
  '0XF2038',
  '0XF2039',
  '0XF203B',
  '0XF2208',
  '0XF2209',
  '0XF220A',
  '0XF244C',
  '0XF244D',
  '0XF244E',
];

const temp_ids = [
  '0X80F2848',
  '0X80F47D0',
  '0X80F2849',
  '0X80F47D1',
  '0X80F284A',
  '0X80F47D2',
  '0X80F284B',
  '0X80F47D3',
  '0X80F284C',
  '0X80F47D4',
  '0X80F284D',
  '0X80F47D5',
  '0x001FFBB6',
  '0x001FFF9E',
  '0x001FFBB5',
  '0x001FFF9D',
];

const all_data_ids = {
  //温度
  '0X80F2848': 'ACTUAL_TEMP1',
  '0X80F47D0': 'SET_TEMP1',
  '0X80F2849': 'ACTUAL_TEMP2',
  '0X80F47D1': 'SET_TEMP2',
  '0X80F284A': 'ACTUAL_TEMP3',
  '0X80F47D2': 'SET_TEMP3',
  '0X80F284B': 'ACTUAL_TEMP4',
  '0X80F47D3': 'SET_TEMP4',
  '0X80F284C': 'ACTUAL_TEMP5',
  '0X80F47D4': 'SET_TEMP5',
  '0X80F284D': 'ACTUAL_TEMP6',
  '0X80F47D5': 'SET_TEMP6',
  '0X80F284E': 'ACTUAL_TEMP7',
  '0X80F47D6': 'SET_TEMP7',
  '0X1FFBB6': 'AUSTON_ACTUALDATA_POWERTEMP1',
  '0X1FFF9E': 'AUSTON_ACTUALDATA_POWERTEMP2',
  '0X1FFFA0': 'AUSTON_ACTUALDATA_POWERTEMP3',
  '0X1FFFA2': 'AUSTON_ACTUALDATA_POWERTEMP4',
  '0X1FFFA4': 'AUSTON_ACTUALDATA_POWERTEMP5',
  '0X1FFBB5': 'MOTORTEMP1',
  '0X1FFF9D': 'MOTORTEMP2',
  '0X1FFF9F': 'MOTORTEMP3',
  '0X1FFFA1': 'MOTORTEMP4',
  '0X1FFFA3': 'MOTORTEMP5',
  //品质
  '0XF2032': 'CYCLE_TIME',
  '0XF2033': 'CLAMP_CLOSE_TIME',
  '0XF2034': 'INJECT_TIME',
  '0XF2035': 'TURN_TIME',
  '0XF2036': 'CHARGE_TIME',
  '0XF2037': 'CLAMP_OPEN_TIME',
  '0XF2038': 'INJECT_BACK_TIME',
  '0XF2039': 'EJECT_TIME',
  '0XF203B': 'CLAMP_OPEN_POSITION',
  '0XF2208': 'INJECT_START_POSITION',
  '0XF2209': 'INJECT_END_POSITION',
  '0XF220A': 'TURN_POSITION',
  '0XF244C': 'TURN_PRESSURE',
  '0XF244D': 'INJECT_MAX_PRESSURE',
  '0XF244E': 'CHARGE_MAX_PRESSURE',
  //其他
  '0X80F29B1': 'TempOil_Current', //CurrentTempOil:油温
  '0XF203C': 'ClampCloseProtectTime', //关模低压计时
  '0XF203D': 'ClampCloseHighTime',//关模高压计时
  '0XF203E': 'EjectAdvTime', //脱进计时
  '0XF203F': 'EjectRetTime', //脱退计时
  '0XF203A': 'FetchTime', //取件时间
  '0X10F4001': 'CoolingTime', //冷却计时
  '0X40F91F4': 'RemnantPosition', //tmRemnantPosi:残料位置	
};

const quality_temp_other_ids = [
  '0XF2032',
  '0XF2033',
  '0XF2034',
  '0XF2035',
  '0XF2036',
  '0XF2037',
  '0XF2038',
  '0XF2039',
  '0XF203B',
  '0XF2208',
  '0XF2209',
  '0XF220A',
  '0XF244C',
  '0XF244D',
  '0XF244E',
  '0X80F2848',
  '0X80F47D0',
  '0X80F2849',
  '0X80F47D1',
  '0X80F284A',
  '0X80F47D2',
  '0X80F284B',
  '0X80F47D3',
  '0X80F284C',
  '0X80F47D4',
  '0X80F284D',
  '0X80F47D5',
  '0X80F284E',
  '0X80F47D6',
  '0X1FFBB6',
  '0X1FFF9E',
  '0X1FFBB5',
  '0X1FFF9D',
  '0X1FFFA0',
  '0X1FFFA2',
  '0X1FFFA4',
  '0X1FFF9F',
  '0X1FFFA1',
  '0X1FFFA3',
  '0X80F29B1',
  '0XF203C',
  '0XF203D',
  '0XF203E',
  '0XF203F',
  '0XF203A',
  '0X10F4001',
  '0X40F91F4'
];


export { data_ids, quality_ids, temp_ids, quality_temp_other_ids, all_data_ids };
